import {Component, Input, OnInit} from "@angular/core";
import {RoleService} from "../../services/role.service";

@Component({
  selector: 'app-companies-nav',
  templateUrl: './companies-nav.component.html',
  styleUrls: ['./companies-nav.component.css']
})
export class CompaniesNavComponent implements OnInit {

  @Input() activeMenuItem = '';

  constructor() { }

  ngOnInit(): void {
  }

}
